import React from "react";
import { InlineDatePicker } from "material-ui-pickers/DatePicker";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import { connect } from "react-redux";
import { appConstants } from "../_constants";

//For domestic views
const domesticTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#43a047",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: '#43a047',
        // color: 'white',
      },
    },
    MuiPickersYear: {
      Year: {
        color: "#43a047",
      },
      selected: {
        color: "#43a047",
      },
    },
    MuiPickersDay: {
      day: {
        // color: '#43a047',
      },
      selected: {
        backgroundColor: "#43a047",
        "&:hover": {
          backgroundColor: "#43a047",
        },
      },
      current: {
        color: "#43a047",
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: "#43a047",
      },
    },
  },
});

//for regional view
const regionalTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        background: `linear-gradient(60deg, ${
          appConstants.REGIONAL_LIGHT_COLOR
        }, ${appConstants.REGIONAL_COLOR})`,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: '#43a047',
        // color: 'white',
      },
    },
    MuiPickersYear: {
      Year: {
        color: appConstants.REGIONAL_LIGHT_COLOR,
      },
      selected: {
        color: appConstants.REGIONAL_LIGHT_COLOR,
      },
    },
    MuiPickersDay: {
      day: {
        // color: '#43a047',
      },
      selected: {
        backgroundColor: appConstants.REGIONAL_LIGHT_COLOR,
        "&:hover": {
          backgroundColor: appConstants.REGIONAL_LIGHT_COLOR,
        },
      },
      current: {
        color: appConstants.REGIONAL_LIGHT_COLOR,
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: appConstants.REGIONAL_LIGHT_COLOR,
      },
    },
  },
});

const inlineDatePicker = (props) => {
  const { Date, handleDateChange, label, minDate, maxDate, ...rest } = props;
  return (
    <MuiThemeProvider
      theme={props.setView === "regional" ? regionalTheme : domesticTheme}
    >
      <InlineDatePicker
        keyboard
        variant="outlined"
        label={label ? label : "Date"}
        value={Date}
        onChange={handleDateChange}
        format="DD/MM/YYYY"
        mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
        minDate={minDate}
        maxDate={maxDate}
        {...rest}
      />
    </MuiThemeProvider>
  );
};

function mapStateToProps(state) {
  const { setView } = state;
  return {
    setView,
  };
}

export default connect(mapStateToProps)(inlineDatePicker);



// WEBPACK FOOTER //
// ./src/utils/InlineDatePicker.js